import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=c9573cac&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=ts&"
export * from "./Support.vue?vue&type=script&lang=ts&"
import style0 from "./Support.vue?vue&type=style&index=0&id=c9573cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9573cac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
